import { render } from "./szdw.vue?vue&type=template&id=369849c3"
const script = {}

import exportComponent from "D:\\项目\\国科大-中国科学院-大学\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__